import React from 'react';
import { Box, Grid, Alert } from '@mui/material';
import RacoonLoading from 'src/components/RacoonLoading';
import OutletCategorySection from './components/OutletCategorySection';
import OutletListContainer from './components/OutletListContainer';
import useOutletManagement from 'src/hooks/useOutletManagement';

const ManageOutlets = () => {
  const {
    error,
    loading,
    favouritedOutlets,
    blacklistedOutlets,
    expandedFavorites,
    expandedBlacklisted,
    setExpandedFavorites,
    setExpandedBlacklisted,
    handleTypeChange,
    filteredOutlets,
    totalCount,
    allOutlets,
    hasMore,
    handleLoadMore,
    searchQuery,
    setSearchQuery,
    allOutletNames,
  } = useOutletManagement();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <RacoonLoading />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Grid container spacing={2}>
        {/* Favourited Outlets */}
        <Grid item xs={12} md={6}>
          <OutletCategorySection
            title="Favourited Outlets"
            outlets={favouritedOutlets}
            expanded={expandedFavorites}
            setExpanded={setExpandedFavorites}
            onTypeChange={handleTypeChange}
            bgColor="primary.main"
          />
        </Grid>

        {/* Blacklisted Outlets */}
        <Grid item xs={12} md={6}>
          <OutletCategorySection
            title="Blacklisted Outlets"
            outlets={blacklistedOutlets}
            expanded={expandedBlacklisted}
            setExpanded={setExpandedBlacklisted}
            onTypeChange={handleTypeChange}
            bgColor="error.main"
          />
        </Grid>
      </Grid>

      {/* Search Bar and All Outlets */}
      <OutletListContainer
        filteredOutlets={filteredOutlets}
        totalCount={totalCount}
        allOutlets={allOutlets}
        hasMore={hasMore}
        handleLoadMore={handleLoadMore}
        onTypeChange={handleTypeChange}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        allOutletNames={allOutletNames}
      />
    </Box>
  );
};

export default ManageOutlets;
